import { render, staticRenderFns } from "./TrailerCharts.vue?vue&type=template&id=22561416&scoped=true"
import script from "./TrailerCharts.vue?vue&type=script&lang=js"
export * from "./TrailerCharts.vue?vue&type=script&lang=js"
import style0 from "./TrailerCharts.vue?vue&type=style&index=0&id=22561416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22561416",
  null
  
)

export default component.exports